<script setup lang="ts">
import ProductList from '~/components/plp/ProductList.vue';
import { useRoute } from 'vue-router';
import {
	fetchNodeProducts,
	fetchProductsCount,
	useProductsCount,
	useProductsList,
} from '~/data/products';
import FilterBar from '~/components/filter-bar/index.vue';
import Description from '~/components/plp/Description.vue';
import { Separator } from 'radix-vue';
const { $cathodeClient } = useNuxtApp();

const route = useRoute();
const handle = route.params.handle as string;

const mapping = {
	'red-saree': {
		node: 407,
		attribute:
			'attrs=color-type.maroon,color-type.red,color-type.cherry+red,color-type.tea+rose,color-type.hot+pink,color-type.blush+pink',
		metaTitle: 'Red Saree',
		metaDescription:
			'Shop LAAM’s elegant red saree collection, perfect for weddings, parties, and special events. Discover timeless red sarees designed to make a statement.',
		onPageSeo:
			'Shop the latest in trendy clothing at LAAM. Discover a wide range of stylish outfits, from traditional wear to everyday essentials. Whether you’re looking for elegant sarees, modern abayas, chic dresses, or comfortable casuals, our collection has it all. With options for every occasion, LAAM brings you affordable, high-quality clothing that fits your style. Explore our selection today and find the perfect piece to elevate your wardrobe.',
		productCount: '30',
	},
	'black-saree': {
		node: 407,
		attribute: 'attrs=color-type.black,color-type.mid+night',
		metaTitle: 'Black Saree',
		metaDescription:
			'Discover the elegance of black sarees at LAAM. From classic designs to modern styles, find your perfect black saree for weddings, parties, and special occasions. Shop now for timeless sophistication.',
		onPageSeo:
			'Embrace timeless elegance with LAAM’s exclusive black saree collection. Known for their versatility and charm, black sarees are perfect for weddings, parties, evening gatherings, or any special occasion where you want to make a statement. Our collection features a variety of styles, from classic embroidered sarees to sleek, modern designs crafted from luxurious fabrics. A black saree is more than just an outfit—it’s a symbol of sophistication and grace that suits every skin tone and body type. Browse our black sarees today to add this iconic piece to your wardrobe and elevate your style with effortless charm.',
		productCount: '57',
	},
	'chiffon-dress': {
		node: 3,
		attribute: 'attrs=shirt-fabrics.chiffon',
		metaTitle: 'Chiffon Dress',
		metaDescription:
			'Explore elegant chiffon dresses at LAAM, perfect for formal events, parties, and casual wear. Shop our chiffon dress collection to add a touch of grace and flow to your wardrobe.',
		onPageSeo:
			'Discover the effortless elegance of chiffon dresses at LAAM. Our collection offers a variety of chiffon styles that blend beauty with comfort, making them ideal for formal occasions, evening parties, or casual day wear. Known for its light, flowy texture, chiffon brings an airy grace to every look, whether it’s a classic maxi dress, a chic midi, or a glamorous evening gown. Available in stunning colors and intricate designs, each chiffon dress is crafted to add movement and sophistication to your wardrobe. Shop LAAM’s chiffon dress collection today and elevate your style with this timeless fabric.',
		productCount: '3101',
	},
	'black-kurta': {
		node: '181,531,56',
		attribute:
			'attrs=color-type.black,color-type.jet+black,color-type.mid+night',
		metaTitle: 'Black Kurta',
		metaDescription:
			'Explore elegant chiffon dresses at LAAM, perfect for formal events, parties, and casual wear. Shop our chiffon dress collection to add a touch of grace and flow to your wardrobe.',
		onPageSeo:
			'Discover the effortless elegance of chiffon dresses at LAAM. Our collection offers a variety of chiffon styles that blend beauty with comfort, making them ideal for formal occasions, evening parties, or casual day wear. Known for its light, flowy texture, chiffon brings an airy grace to every look, whether it’s a classic maxi dress, a chic midi, or a glamorous evening gown. Available in stunning colors and intricate designs, each chiffon dress is crafted to add movement and sophistication to your wardrobe. Shop LAAM’s chiffon dress collection today and elevate your style with this timeless fabric.',
		productCount: '1011',
	},
	'bridal-wear': {
		node: 1,
		attribute: 'attrs=product-type.bride/groom+wear',
		title: 'Bridal Wear',
		metaTitle:
			'Buy Pakistani Bridal Dresses & Wedding Wear Online in Pakistan - Laam.pk',
		metaDescription:
			'Discover the finest collection of Pakistani bridal dresses, including bridal gowns, lehengas, and Barat dresses, online in Pakistan at best prices. Shop for Nikkah dresses, bridal maxi dresses, and Maria B bridal wear for your big day',
		onPageSeo:
			// eslint-disable-next-line quotes
			"<h2>Pakistani Bridal Dresses: Elegant and Traditional Styles</h2> <p>Pakistani bridal dresses are known for their rich tradition, intricate designs, and stunning embellishments. Whether you're looking for a classic bridal gown dress or a more traditional Pakistani bridal wear, there’s a wide range of options to make your wedding day unforgettable. Popular styles include bridal Pakistani suits, Pakistani bridal gowns, and Asian Pakistani wedding dresses, each crafted with attention to detail and cultural significance. These dresses often feature luxurious fabrics, intricate embroidery, and beautiful embellishments, making them the perfect choice for any bride.</p> <h3>Traditional Bridal Dresses for Special Events</h3><p>For the Barat or Nikkah ceremony, brides can choose from elegant Barat dresses and Nikkah dresses for brides that are designed to reflect the significance of the event. Barat dresses for bridal typically feature heavy embroidery and vibrant colors, while simple Nikkah dresses for brides offer a more understated elegance. Pakistani wedding frocks or Pakistani bridal lehengas are also stunning choices, providing a blend of tradition and style.</p><h3>Wedding Wear for Pakistani Brides</h3><p>In addition to the bridal wedding dress Pakistani, brides can choose from a variety of Pakistani wedding outfits such as bridal Pakistani outfits and wedding wear dresses in Pakistan. These dresses come in a variety of styles, from elaborate Pakistani wedding lehengas to more modern red bridal dresses and red wedding gowns. Many brides also opt for Maria B wedding collection and Kashee bridal dresses, which offer a range of beautiful, high-quality designs.</p><h3>Affordable and Customizable Options</h3><p>While some brides opt for luxury designs, there are also Pakistani bridal dresses with prices that suit various budgets. Whether you're looking for a simple bridal dress in Pak or a more elaborate Pakistani wedding gown dress, there are options available for every bride. Pakistani wedding dresses with prices can be found across a variety of collections, ensuring there's something to suit your personal taste and budget.</p>",
		productCount: '1454',
	},
	'black-dresses': {
		node: 2,
		attribute:
			'attrs=color-type.black,color-type.jet+black,color-type.mid+night',
		metaTitle: 'Black Dresses',
		metaDescription:
			'Shop LAAM’s stylish black dress collection for every occasion. From casual to formal wear, find the perfect black dress to elevate your wardrobe with timeless elegance.',
		onPageSeo:
			'Discover the allure of classic black dresses at LAAM, where style meets versatility. Our collection of black dresses is designed for every occasion, from chic casual outings to formal gatherings and evening events. Choose from a range of silhouettes, including sleek midi dresses, glamorous evening gowns, and timeless little black dresses, each crafted with premium fabrics and attention to detail. Black dresses are wardrobe essentials, offering effortless elegance and sophistication that never goes out of style. Explore our collection today to find the perfect black dress that complements your unique look.',
		productCount: '2782',
	},
	'mehndi-dress': {
		node: '182,6,296,520,187,299',
		attribute:
			'attrs=product-type.bride/groom+wear,product-type.wedding/guest+wear+-+formal,product-type.festive/party+wear,color-type.green,color-type.yellow,color-type.mustard,color-type.multi,color-type.orange,color-type.gold,color-type.bottle+green,color-type.olive,color-type.magenta,color-type.shocking+pink,color-type.rust,color-type.lemon+yellow,color-type.emerald,color-type.copper+orange',
		title: 'Mehndi Dresses',
		metaTitle:
			'Shop Mehndi Dresses for Brides, Grooms & Guests in Pakistan - Laam.pk',
		metaDescription:
			'Explore a wide range of mehndi dresses for brides, grooms, and guests online in Pakistan at the best prices. Find colorful, simple, and bridal mehndi outfits, lehengas, frocks, and more at Laam.pk',
		onPageSeo:
			// eslint-disable-next-line quotes
			"<h2>Mehndi Dresses: Colorful and Traditional Celebrations</h2><p>Mehndi, one of the most vibrant and joyful pre-wedding celebrations, calls for special attire that reflects the festive spirit. Mehndi dresses are a blend of traditional and contemporary styles, featuring intricate embroidery, vibrant colors, and designs that suit both brides and grooms. Whether you're shopping for a bridal mehndi dress, a groom dress for mehndi, or a stylish outfit for the mehndi function, the right dress can elevate your celebration. Mehndi outfits for both men and women come in various styles, such as lehenga for mehndi, mehndi sharara, or even simple salwar kameez designs, ensuring everyone looks their best.</p><h3>Bridal and Groom Mehndi Dresses</h3><p>For brides, the bridal mehendi dress is often a key highlight, with choices ranging from colorful mehndi dresses to bridal mehndi lehengas in stunning hues. Brides can choose from traditional styles like the mehndi lehnga dress or more contemporary outfits like mehndi suits. Groom dress for mehndi also plays an important role, with designs that match the vibrancy of the event. From mehndi dress simple to mehndi dress with sharara, the groom's outfit can be equally festive and stylish.</p><h3>Colorful Mehndi Outfits for Everyone</h3><p>Mehndi outfits for guys and women include a variety of bold, bright colors, such as green mehndi dress, yellow mehndi dress, and green mehandi dress. These outfits reflect the joyous occasion, incorporating traditional elements like lehenga for mehndi, mehandi sharara, or kurtas for mehndi. For brides and guests, mayon dress or casual simple mehndi dresses are perfect for a laid-back yet fashionable look.</p><h3>Shopping for Mehndi Dresses in Pakistan</h3><p>In Pakistan, mehndi dresses are designed with rich cultural elements, featuring luxurious fabrics, vibrant hues, and stunning embellishments. Pakistani mehndi dresses include elegant options like mehndi lehenga, mehndi sharara, and simple Pakistani mehndi dresses. You can also find Asim Jofa mehndi dresses or Maria B mehndi dresses, known for their exquisite designs. Whether you're looking for mehndi dresses for ladies in Pakistan or finding the perfect outfit for the bride or groom, there's no shortage of beautiful options to choose from.</p>",
		productCount: '775',
	},
	'velvet-dress': {
		node: 1,
		attribute: 'attrs=shirt-fabrics.velvet',
		metaTitle: 'Velvet Dress',
		metaDescription:
			'Explore luxurious velvet dresses at LAAM, perfect for winter events and special occasions. Discover rich textures and elegant designs to elevate your style',
		onPageSeo:
			// eslint-disable-next-line quotes
			"Add a touch of luxury to your wardrobe with LAAM’s exquisite velvet dress collection. Known for its rich texture and warmth, velvet is the perfect fabric for winter gatherings, evening events, and festive occasions. Our collection includes a range of styles, from classic velvet gowns to chic midi dresses, each crafted to bring elegance and sophistication to your look. Whether you're dressing up for a wedding, a party, or an evening out, a velvet dress offers both comfort and style. Shop LAAM’s velvet dress collection today and make a statement with timeless elegance.",
		productCount: '528',
	},
};
const set = mapping[handle as keyof typeof mapping];

if (!set) {
	throw createError({
		statusCode: 404,
		message: 'Set not found' + route.fullPath,
		data: {
			url: route.fullPath,
		},
		stack: undefined,
		fatal: true,
	});
}
const nodeId = set.node;
const attribute = set.attribute;

const attrsFilters = (() => {
	const [key, value] = attribute.split('=');
	if (!key || !value) return {};
	return { [key]: value };
})();

const routeName = 'set-handle';
const filters = useFilterParams(routeName);

useHead({
	title: set.metaTitle || set.title,
	titleTemplate: null,
	meta: [
		{
			name: 'description',
			content: set.metaDescription,
		},
	],
});

onMounted(() => {
	$cathodeClient.queueEvent('page_load', {
		source: `${window.location.origin}${route.path}`,
		page: 'PLP',
		statusCode: 200,
		referrer: document.referrer,
		collection_handle: route.params.handle as string,
	});
});

watch(route, () => {
	if (!route.fullPath) {
		throw new Error('route.fullPath is not defined');
	}
});

const count = useProductsCount({
	routeName,
	queryKey: ['nodes', handle, filters],
	queryFn: () =>
		fetchProductsCount({
			node_id: nodeId.toString(),
			...attrsFilters,
			...filters.value,
		}),
});

const allowSSR = true;
const {
       data,
       isLoading,
       hasNextPage,
       fetchNextPage,
       suspense,
       isFetchingNextPage,
       error: productListError,
} = useProductsList({
       routeName,
       queryKey: ['sets', nodeId, filters],
       queryFn: ({ pageParam: cursor }) => {
               return fetchNodeProducts(nodeId.toString(), cursor as string, {
                       ...attrsFilters,
                       ...filters.value,
               });
       },
       allowSSR,
});

onServerPrefetch(async () => {
       await suspense();
});
watch(isLoading, (isLoading) => {
	if (!isLoading && productListError.value) {
		throw createError({
			statusCode: 404,
			message: 'Failed to load products',
			data: {
				url: route.fullPath,
			},
			fatal: true,
		});
	}
});
</script>
<template>
	<div>
		<PlpHeader
			:data="{
				title: set?.title || set.metaTitle,
				subtitle: set.productCount,
				description: set.metaDescription,
			}"
			:items-count="count"
		/>
                <ClientOnly>
                        <FilterBar
                                :node-ids="nodeId"
                                :is-product-list-loading="isLoading"
                                :handle="handle"
                                :filters-from-prop="attribute"
                        />
                        <template #fallback>
                                <FilterBarSkeleton />
                        </template>
                </ClientOnly>
                <ProductList
                        :infinite-loader="true"
                        :fetch-next-page="fetchNextPage"
                        :is-loading="isLoading"
                        :data="data"
                        :has-next-page="hasNextPage"
                        :is-fetching-next-page="isFetchingNextPage"
                />
		<Separator class="seo-description-separator" />
		<Description
			:description="set.onPageSeo"
			:heading="set?.title || set.metaTitle"
		/>
	</div>
</template>

<style scoped>
.seo-description-separator {
	@apply !bg-gray-100 h-xl mt-5xl;
}
</style>
